export const SoundOnIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_timeline_sound_on)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.06066 9.93934C4.77936 9.65804 4.39782 9.5 4 9.5H2C1.72386 9.5 1.5 9.27614 1.5 9V7C1.5 6.72386 1.72386 6.5 2 6.5H4C4.39782 6.5 4.77936 6.34196 5.06066 6.06066L7.54289 3.57843C7.59311 3.52821 7.66122 3.5 7.73223 3.5C7.88012 3.5 8 3.61988 8 3.76777V12.2322C8 12.3801 7.88012 12.5 7.73223 12.5C7.66122 12.5 7.59311 12.4718 7.54289 12.4216L5.06066 9.93934ZM2 5H4L6.48223 2.51777C6.81375 2.18625 7.26339 2 7.73223 2C8.70854 2 9.5 2.79146 9.5 3.76777V12.2322C9.5 13.2085 8.70854 14 7.73223 14C7.26339 14 6.81375 13.8138 6.48223 13.4822L4 11H2C0.89543 11 0 10.1046 0 9V7C0 5.89543 0.895431 5 2 5ZM14.1617 13.1026C13.8974 13.4215 13.4194 13.4195 13.1265 13.1266C12.8336 12.8337 12.8376 12.3612 13.095 12.0367C13.9746 10.9279 14.5 9.52533 14.5 8.00005C14.5 6.47477 13.9746 5.0722 13.095 3.96341C12.8376 3.63892 12.8336 3.16642 13.1265 2.87353C13.4194 2.58063 13.8974 2.57858 14.1617 2.89746C15.3099 4.28234 16 6.0606 16 8.00005C16 9.93951 15.3099 11.7178 14.1617 13.1026ZM12.0244 10.9677C11.7783 11.3009 11.2981 11.2981 11.0052 11.0053C10.7123 10.7124 10.7207 10.2406 10.9449 9.89229C11.2962 9.3467 11.5 8.69718 11.5 8.00005C11.5 7.30292 11.2962 6.6534 10.9449 6.10782C10.7207 5.75955 10.7123 5.28774 11.0052 4.99485C11.2981 4.70195 11.7783 4.69919 12.0244 5.03236C12.6376 5.86242 13 6.88891 13 8.00005C13 9.11119 12.6376 10.1377 12.0244 10.9677Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_timeline_sound_on">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SoundOffIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_timeline_sound_off)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.03033 1.96967C2.73744 1.67678 2.26256 1.67678 1.96967 1.96967C1.67678 2.26256 1.67678 2.73744 1.96967 3.03033L3.93934 5H2C0.895431 5 0 5.89543 0 7V9C0 10.1046 0.89543 11 2 11H4L6.48223 13.4822C6.81375 13.8138 7.26339 14 7.73223 14C8.70854 14 9.5 13.2085 9.5 12.2322V10.5607L12.9697 14.0303C13.2626 14.3232 13.7374 14.3232 14.0303 14.0303C14.3232 13.7374 14.3232 13.2626 14.0303 12.9697L3.03033 1.96967ZM8 9.06066L5.0299 6.09056C4.75187 6.35314 4.3835 6.5 4 6.5H2C1.72386 6.5 1.5 6.72386 1.5 7V9C1.5 9.27614 1.72386 9.5 2 9.5H4C4.39782 9.5 4.77936 9.65804 5.06066 9.93934L7.54289 12.4216C7.59311 12.4718 7.66122 12.5 7.73223 12.5C7.88012 12.5 8 12.3801 8 12.2322V9.06066ZM8 3.76777V4.79792L9.5 6.29792V3.76777C9.5 2.79146 8.70854 2 7.73223 2C7.26339 2 6.81375 2.18625 6.48223 2.51777L6.10104 2.89896L7.1617 3.95962L7.54289 3.57843C7.59311 3.52821 7.66122 3.5 7.73223 3.5C7.88012 3.5 8 3.61988 8 3.76777ZM11.4886 8.28651L12.7545 9.55245C12.9139 9.06383 13.0001 8.54213 13.0001 8.0003C13.0001 6.88915 12.6377 5.86266 12.0246 5.03261C11.7785 4.69943 11.2982 4.7022 11.0053 4.99509C10.7124 5.28798 10.7208 5.7598 10.945 6.10806C11.2963 6.65365 11.5001 7.30317 11.5001 8.0003C11.5001 8.09666 11.4962 8.19211 11.4886 8.28651ZM13.9107 10.7087L15.0279 11.8258C15.6478 10.6894 16.0001 9.38598 16.0001 8.0003C16.0001 6.06084 15.31 4.28258 14.1619 2.89771C13.8975 2.57883 13.4195 2.58088 13.1267 2.87377C12.8338 3.16666 12.8377 3.63916 13.0951 3.96366C13.9748 5.07244 14.5001 6.47502 14.5001 8.0003C14.5001 8.96687 14.2891 9.88417 13.9107 10.7087Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_timeline_sound_off">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const KeyframeIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_keyframe_outline)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.0104 6.93934L9.06066 1.98959C8.47487 1.4038 7.52513 1.4038 6.93934 1.98959L1.98959 6.93934C1.40381 7.52512 1.40381 8.47487 1.98959 9.06066L6.93934 14.0104C7.52513 14.5962 8.47487 14.5962 9.06066 14.0104L14.0104 9.06066C14.5962 8.47487 14.5962 7.52512 14.0104 6.93934ZM10.1213 0.92893C8.94975 -0.242643 7.05025 -0.242643 5.87868 0.92893L0.928932 5.87868C-0.242641 7.05025 -0.242641 8.94974 0.928932 10.1213L5.87868 15.0711C7.05025 16.2426 8.94975 16.2426 10.1213 15.0711L15.0711 10.1213C16.2426 8.94975 16.2426 7.05025 15.0711 5.87868L10.1213 0.92893Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_keyframe_outline">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const KeyframeFilledIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_keyframe_filled)">
      <path
        d="M5.87868 0.928937C7.05025 -0.242635 8.94975 -0.242635 10.1213 0.928937L15.0711 5.87868C16.2426 7.05026 16.2426 8.94975 15.0711 10.1213L10.1213 15.0711C8.94975 16.2426 7.05025 16.2426 5.87868 15.0711L0.928932 10.1213C-0.24264 8.94975 -0.242641 7.05026 0.928932 5.87868L5.87868 0.928937Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_keyframe_filled">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const WorkareaIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.5 2.75C1.5 2.33579 1.16421 2 0.75 2C0.335786 2 0 2.33579 0 2.75V13.25C0 13.6642 0.335786 14 0.75 14C1.16421 14 1.5 13.6642 1.5 13.25V2.75ZM16 2.75C16 2.33579 15.6642 2 15.25 2C14.8358 2 14.5 2.33579 14.5 2.75V13.25C14.5 13.6642 14.8358 14 15.25 14C15.6642 14 16 13.6642 16 13.25V2.75ZM6.53033 4.96967C6.82322 5.26256 6.82322 5.73744 6.53033 6.03033L4.56066 8L6.53033 9.96967C6.82322 10.2626 6.82322 10.7374 6.53033 11.0303C6.23744 11.3232 5.76256 11.3232 5.46967 11.0303L2.96967 8.53033C2.67678 8.23744 2.67678 7.76256 2.96967 7.46967L5.46967 4.96967C5.76256 4.67678 6.23744 4.67678 6.53033 4.96967ZM9.46967 6.03033C9.17678 5.73744 9.17678 5.26256 9.46967 4.96967C9.76256 4.67678 10.2374 4.67678 10.5303 4.96967L13.0303 7.46967C13.3232 7.76256 13.3232 8.23744 13.0303 8.53033L10.5303 11.0303C10.2374 11.3232 9.76256 11.3232 9.46967 11.0303C9.17678 10.7374 9.17678 10.2626 9.46967 9.96967L11.4393 8L9.46967 6.03033Z"
      fill="currentColor"
    />
  </svg>
);

export const WorkareaActiveIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.5 2.75C1.5 2.33579 1.16421 2 0.75 2C0.335786 2 0 2.33579 0 2.75V13.25C0 13.6642 0.335786 14 0.75 14C1.16421 14 1.5 13.6642 1.5 13.25V2.75ZM16 2.75C16 2.33579 15.6642 2 15.25 2C14.8358 2 14.5 2.33579 14.5 2.75V13.25C14.5 13.6642 14.8358 14 15.25 14C15.6642 14 16 13.6642 16 13.25V2.75ZM3.46967 4.96967C3.17678 5.26256 3.17678 5.73744 3.46967 6.03033L5.43934 8L3.46967 9.96967C3.17678 10.2626 3.17678 10.7374 3.46967 11.0303C3.76256 11.3232 4.23744 11.3232 4.53033 11.0303L7.03033 8.53033C7.32322 8.23744 7.32322 7.76256 7.03033 7.46967L4.53033 4.96967C4.23744 4.67678 3.76256 4.67678 3.46967 4.96967ZM12.5303 6.03033C12.8232 5.73744 12.8232 5.26256 12.5303 4.96967C12.2374 4.67678 11.7626 4.67678 11.4697 4.96967L8.96967 7.46967C8.67678 7.76256 8.67678 8.23744 8.96967 8.53033L11.4697 11.0303C11.7626 11.3232 12.2374 11.3232 12.5303 11.0303C12.8232 10.7374 12.8232 10.2626 12.5303 9.96967L10.5607 8L12.5303 6.03033Z"
      fill="currentColor"
    />
  </svg>
);

export const AnimatedLayersIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 4.25C2 3.83579 2.33579 3.5 2.75 3.5H8.25C8.66421 3.5 9 3.83579 9 4.25C9 4.66421 8.66421 5 8.25 5H2.75C2.33579 5 2 4.66421 2 4.25Z"
      fill="currentColor"
    />
    <path
      d="M2 8C2 7.58579 2.33579 7.25 2.75 7.25H5.25C5.66421 7.25 6 7.58579 6 8C6 8.41421 5.66421 8.75 5.25 8.75H2.75C2.33579 8.75 2 8.41421 2 8Z"
      fill="currentColor"
    />
    <path
      d="M2 11.75C2 11.3358 2.33579 11 2.75 11H8.25C8.66421 11 9 11.3358 9 11.75C9 12.1642 8.66421 12.5 8.25 12.5H2.75C2.33579 12.5 2 12.1642 2 11.75Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.5607 2.46967C11.8536 2.17678 12.3284 2.17678 12.6213 2.46967L14.5303 4.37868C14.8232 4.67157 14.8232 5.14645 14.5303 5.43934L12.6213 7.34835C12.3284 7.64124 11.8536 7.64124 11.5607 7.34835L9.65165 5.43934C9.35876 5.14645 9.35876 4.67157 9.65165 4.37868L11.5607 2.46967ZM12.091 4.03033L11.2426 4.87868L12.091 5.72703L12.9393 4.87868L12.091 4.03033Z"
      fill="currentColor"
    />
    <path
      d="M12.091 8.5C12.5052 8.5 12.841 8.83579 12.841 9.25V10H13.591C14.0052 10 14.341 10.3358 14.341 10.75C14.341 11.1642 14.0052 11.5 13.591 11.5H12.841V12.25C12.841 12.6642 12.5052 13 12.091 13C11.6767 13 11.341 12.6642 11.341 12.25V11.5H10.591C10.1767 11.5 9.841 11.1642 9.841 10.75C9.841 10.3358 10.1767 10 10.591 10H11.341V9.25C11.341 8.83579 11.6767 8.5 12.091 8.5Z"
      fill="currentColor"
    />
  </svg>
);
